export default __webpack_public_path__ + "static/logo_snn-aedfe389f839a0802ef29942d4d45d6a.png";